import { render, staticRenderFns } from "./DTSHome.vue?vue&type=template&id=95dcda34&"
import script from "./DTSHome.vue?vue&type=script&lang=js&"
export * from "./DTSHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports